
import equiv from "./equiv.js";
export default function scrollToAnchor(anchor) {
    anchor = equiv(anchor.indexOf('#'), 0) ? anchor : `#${anchor}`;
    window.location.href = anchor;
}